import { loadingSpinnerActions } from "../../actions/loadingSpinnerActions";
var ReviewsReduxProps = {
    mapDispatchToProps: function (dispatch) {
        return {
            onShowSpinner: function () { return dispatch({ type: loadingSpinnerActions.SHOW_SPINNER_MODAL }); },
            onHideSpinner: function () { return dispatch({ type: loadingSpinnerActions.HIDE_SPINNER_MODAL }); },
        };
    }
};
export default ReviewsReduxProps;



//////////////////
// WEBPACK FOOTER
// ./src/views/Reviews/ReviewsReduxProps.ts
// module id = 439
// module chunks = 0